export default __webpack_public_path__ + "static/media/logotype-home.3d9c4faa.svg";